/* eslint-disable no-case-declarations */
import { DELETE_IMG, } from '../actions/types/UploadTypes';
import api from '../controllers/api/config';
import { CHECK_TOKEN } from '../actions/types/UserTypes';
import { SPINNER_ON, SPINNER_OFF } from '../actions/types/CommonTypes';
const checkCommon = (store) => (next) => (action) => {
    switch (action.type) {
        case DELETE_IMG:
            next(action);
            store.dispatch({ type: SPINNER_ON });
            api.image.deleteAvatar()
                .then(() => store.dispatch({ type: CHECK_TOKEN }))
                .catch(() => {
                // TODO implement me!
            })
                .finally(() => store.dispatch({ type: SPINNER_OFF }));
            break;
        default:
            next(action);
    }
};
export default checkCommon;
